export class SharePatientSerializer {
  static deserialize = info => (
    info && {
      patientId: info.patient_id,
      patientName: info.patient_name,
      requestId: info.request_id,
    }
  );
}
